// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file responses/v1/package_providers_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/package_providers_response.proto.
 */
export const file_responses_v1_package_providers_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'Ci1yZXNwb25zZXMvdjEvcGFja2FnZV9wcm92aWRlcnNfcmVzcG9uc2UucHJvdG8SDHJlc3BvbnNlcy52MSJUChhQYWNrYWdlUHJvdmlkZXJzUmVzcG9uc2USOAoRcGFja2FnZV9wcm92aWRlcnMYASADKAsyHS5yZXNwb25zZXMudjEuUGFja2FnZVByb3ZpZGVyIlAKD1BhY2thZ2VQcm92aWRlchIKCgJpZBgBIAEoBBIMCgRuYW1lGAIgASgJEhUKDXRyYW5zbGF0ZV9rZXkYAyABKAkSDAoEY29kZRgEIAEoCUKIAQoQY29tLnJlc3BvbnNlcy52MUIdUGFja2FnZVByb3ZpZGVyc1Jlc3BvbnNlUHJvdG9QAVoELi9wYqICA1JYWKoCDFJlc3BvbnNlcy5WMcoCDFJlc3BvbnNlc1xWMeICGFJlc3BvbnNlc1xWMVxHUEJNZXRhZGF0YeoCDVJlc3BvbnNlczo6VjFiBnByb3RvMw'
    );

/**
 * @generated from message responses.v1.PackageProvidersResponse
 */
export type PackageProvidersResponse = Message<'responses.v1.PackageProvidersResponse'> & {
    /**
     * @generated from field: repeated responses.v1.PackageProvider package_providers = 1;
     */
    packageProviders: PackageProvider[];
};

/**
 * Describes the message responses.v1.PackageProvidersResponse.
 * Use `create(PackageProvidersResponseSchema)` to create a new message.
 */
export const PackageProvidersResponseSchema: GenMessage<PackageProvidersResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_package_providers_response, 0);

/**
 * @generated from message responses.v1.PackageProvider
 */
export type PackageProvider = Message<'responses.v1.PackageProvider'> & {
    /**
     * @generated from field: uint64 id = 1;
     */
    id: bigint;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: string translate_key = 3;
     */
    translateKey: string;

    /**
     * @generated from field: string code = 4;
     */
    code: string;
};

/**
 * Describes the message responses.v1.PackageProvider.
 * Use `create(PackageProviderSchema)` to create a new message.
 */
export const PackageProviderSchema: GenMessage<PackageProvider> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_package_providers_response, 1);
